import React from 'react';

import Spinner from '../../../../../../../components/global/Spinner';

const Placeholder = () => {
  return (
    <div className="text-center my-3">
      <Spinner />
    </div>
  );
};

export default Placeholder;
